import Modal from '@components/App/Modal/Modal'
import NotificationWrapper from '@components/App/NotificationContainer/NotificationWrapper'
import { PromoCrawler as Promo } from '@components/App/PromoCrawler'
import Theme from '@components/ArtBoard/Theme/Theme'
import type React from 'react'

// Handoff route for the crawler extension (route /promo-crawler).
// Promo itself renders nothing, so the notification/modal containers are mounted
// here — without them a failed save dispatches into a route with no renderer and
// the user is left on a blank screen.
export const PromoCrawler: React.FC = () => (
  <Theme>
    <NotificationWrapper />
    <Promo />
    <Modal />
  </Theme>
)
